import { useQuery } from '@apollo/client/react';

import { useCrmConnectionErrorCount } from '@anyx/integrations-crm/shared';


import { GET_INACTIVE_SALE_CHANNELS } from '../graphql';

export const useGetInactiveIntegrations = ({ storeId = '' }: { storeId?: string }) => {
  const { data, loading, error } = useQuery(GET_INACTIVE_SALE_CHANNELS, {
    skip: !storeId,
    variables: { storeId: storeId },
  });
  const crmCount = useCrmConnectionErrorCount({
    storeId: storeId,
  });

  return {
    inactiveIntegrationCount: (data?.onboarding?.inactiveSaleChannelCount || 0) + crmCount,
    loading,
    error,
  };
};
